import type { APIResult } from "./types";

import { getMaintenanceRecords } from "./generated/calls/maintenance-records/maintenance-records";
import type { MaintenanceRecords as MaintenanceRecordDTO } from "./generated/models";
import { buildHeaders } from "./helpers/headerHelper";
import { postgrestError } from "./helpers/postgrestErrorHelper";

export type { MaintenanceRecordDTO };

/**
 * Fetches all fleet maintenance records from the API.
 *
 * Returns an API result containing the fetched maintenance records, or a
 * controlled failure if the request could not be completed.
 */
export async function fetchFleetMaintenanceRecords(): Promise<
  APIResult<MaintenanceRecordDTO[]>
> {
  try {
    const headers = buildHeaders();
    const maintenanceRecordsFetchRes = await getMaintenanceRecords(undefined, {
      headers,
    });

    switch (maintenanceRecordsFetchRes.status) {
      // A read narrowed by `limit`, `offset` or a `Range` header answers 206
      // and carries the same rows as a 200.
      case 200:
      case 206:
        return {
          success: true,
          data: maintenanceRecordsFetchRes.data,
        };
      default:
        throw postgrestError("Fetch failed", maintenanceRecordsFetchRes);
    }
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
